export const light = {
  bg0: '#fafaff',
  bg1: '#f5f5fc',
  bg2: '#eeeef9',
  bg3: '#e4e4f2',
  bg4: '#d8d8eb',

  text0: '#00000e',
  text1: '#6a6f83',
  text2: '#9595a6',
  text3: '#e1dfeb',

  accent0: '#0089E3',
  accent1: '#c75a5a',

  misc0: '#babcd1',
  misc1: '#dddded',
  misc2: '#323947',
  border: '#e6e6f5',

  sidebar0: '#0A090E',
  sidebar1: '#19171D',
  sidebar2: '#232029',

  button0: '#42424F',
  button1: '#31313D',
  button2: '#FAFAFF',
};

export const dark = {
  bg0: '#31313D',
  bg1: '#282832',
  bg2: '#202029',
  bg3: '#19171D',
  bg4: '#09090E',

  text0: '#ECECF7',
  text1: '#9595A6',
  text2: '#6A6F83',

  accent0: '#85C5F9',
  accent1: '#E07070',

  misc0: '#5A5A69',
  misc1: '#3E3E4A',
  misc2: '#ccdbf0',

  sidebar0: '#0A090E',
  sidebar1: '#19171D',
  sidebar2: '#232029',

  button0: '#42424F',
  button1: '#31313D',
  button2: '#FAFAFF',
};
